type Value = string | number;

type Unit = (n: Value) => string;

type ToREM = (n: Value) => string;

type TRBL = (t: Value, r: Value, b: Value, l: Value) => string;
type TXB = (t: Value, x: Value, b: Value) => string;
type YX = (y: Value, x: Value) => string;

type BorderStyle =
  | 'dotted'
  | 'dashed'
  | 'solid'
  | 'double'
  | 'groove'
  | 'ridge'
  | 'inset'
  | 'outset'
  | 'none'
  | 'hidden';
type Border = (width: number, style: BorderStyle, color: string) => string;

interface PxToRem {
  (size: number): string;
  (topBottom: number, rightLeft: number): string;
  (top: number, rightLeft: number, bottom: number): string;
  (top: number, right: number, bottom: number, left: number): string;
}

export const rem: Unit = value => `${value}rem`;
export const vh: Unit = value => `${value}vh`;
export const vw: Unit = value => `${value}vw`;

export const toREM: ToREM = value =>
  typeof value === 'string' || value === 0 ? `${value}` : rem(value);

// trbl = top, right, bottom, left
export const trbl: TRBL = (top, right, bottom, left) =>
  `${toREM(top)} ${toREM(right)} ${toREM(bottom)} ${toREM(left)}`;

// txb = top, x, bottom
// eslint-disable-next-line id-length
export const txb: TXB = (top, x, bottom) =>
  `${toREM(top)} ${toREM(x)} ${toREM(bottom)}`;

// eslint-disable-next-line id-length
export const yx: YX = (y, x) => `${toREM(y)} ${toREM(x)}`;

export const border: Border = (width, style, colour) =>
  `${width}px ${style} ${colour}`;

const pxToRem: PxToRem = (...sizes: ReadonlyArray<number>) =>
  sizes.map(size => `${size / 16}rem`).join(' ');

export interface Units {
  rem: Unit;
  vh: Unit;
  vw: Unit;
  trbl: TRBL;
  txb: TXB;
  yx: YX;
  border: Border;
  pxToRem: PxToRem;
}

const units: Units = { rem, vh, vw, trbl, txb, yx, border, pxToRem };

export { units };
